import React from 'react';

interface SearchBarProps {
  className?: string;
  fetchData?: () => Promise<any>; // Function to call the backend API
  placeholder: string; // Placeholder text
  onSearch: (query: string) => void; // New prop for search handling
}

const SearchBar: React.FC<SearchBarProps> = ({ className, fetchData, placeholder, onSearch }) => {
  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onSearch(event.target.value); // Call the onSearch function with the input value
  };

  return (
    <div 
      style={{ backgroundColor: 'none', padding: 0 }}
      className={`text-black rounded-lg ${className}`}
    >
      <input 
        type="text" 
        placeholder={placeholder} 
        className="border-none outline-none w-full" 
        style={{ backgroundColor: '#e7eef8', color: '#000', border: 'none', boxShadow: '2px', borderRadius: '12px' }} // Increased border radius
        onChange={handleInputChange} // Handle input change
      />
      {/* Additional search functionality can be added here */}
    </div>
  );
};

export default SearchBar;

